/**2022.1.12变更
 * prizeItemType
 * 1、swiper（顶部轮播图中卡片）(不变)
 * 2、list 详情列表中卡片 （变更）
 * 3、popup 弹框中卡片(新增)
 */
import React, { useState } from 'react'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'
import Price from '@/components/Price/Price'
import PrizePopup from './PrizePopup'
import Api from '@/api'
import style from './PrizeItem.module.scss'

const PrizeItem = props => {
  const { prizeItemType, item = {},className='' } = props
  const [maskVisible, setMaskVisible] = useState(false)
  const [stepList, setStepList] = useState([])

  const getDatas = async (id, group) => {
    try {
      const res = await Api.post('/fansbox/detail-bay-group', { id, group } )
      if (!res) return
      setStepList(res || [])
    } catch (error) {
      console.log(error)
    }
  }

  const popupHandle=(val)=>{
    setMaskVisible(val)
  }

  return (
    <div
        className={className}
        onClick={() => {
        if(prizeItemType!=='list')return
        getDatas(item.id, item.group)
        setMaskVisible(true)
      }}
        styleName={classNames({
          item: true,
          [`${prizeItemType}-item`]: true,
        })}
      >
      <div styleName="header">
        {/* 轮播图头 */}
        {prizeItemType === 'swiper' && <span styleName="tag tag-trapezoid">{item.group}奖</span>}
      </div>

      <div styleName="body">
        <div style={{background:`url("${item.cover_image?.thumb_l}")`, backgroundRepeat: 'no-repeat',backgroundSize: 'cover',backgroundPosition: 'center'}} styleName="body-img" >
        </div>

      </div>
      {/* footer */}
      {/* 轮播图卡片 */}
      {prizeItemType === 'swiper' && (
        <div styleName="footer">
          <p styleName="tit">{item.title || item.name}</p>
          <div styleName="price">
            <p styleName="price-tit">市场价:</p>
            <div styleName="price-main">
              <Price extraClass={`fanhe-${prizeItemType}`}
                  price={item.market_price}
                  style={{ color: prizeItemType === 'swiper' ? '#75FBBF' : '#6537D1' }}></Price>
            </div>
            {item?.maket_price_append_text&&<span styleName="price-meta">{item.maket_price_append_text}</span>}
          </div>
        </div>
      )}
      {/* 列表卡片 */}
      {prizeItemType === 'list' && (
        <div styleName="footer">
          <div styleName="card-step">
            <div styleName="tag">{item.group}奖</div>
            <div>{item.progress}</div>
          </div>
          <div styleName="rate">
            <div styleName="rate-tit">概率:</div>
            <div styleName="rate-num">{item.rate_text}</div>
          </div>
        </div>
      )}

      {/* popup */}
      {prizeItemType === 'popup' && (
        <div styleName="footer">
          <p styleName="tit">{item.name}</p>
          <div styleName="price">
            <p styleName="price-tit">市场价:</p>
            <div styleName="price-main">
              <Price extraClass={`fanhe-${prizeItemType}`}
                  price={item.market_price}
                  style={{ color: '#6537D1' }}/>
            </div>
           {item?.maket_price_append_text&&<span styleName="price-meta">{item.maket_price_append_text}</span>}
          </div>
        </div>
      )}

      {prizeItemType !== 'swiper' && item?.sold === true && <div styleName="sold-mask"></div>}

      {prizeItemType === 'list' && (
       <PrizePopup {...{stepList,maskVisible,popupHandle}}
           prizeStep={item.group}
       />
      )}
    </div>
  )
}
// export default PrizeItem
export default CSSModules(PrizeItem, style, { allowMultiple: true })
